import { render, staticRenderFns } from "./Type2Form.vue?vue&type=template&id=3d811569&scoped=true&"
import script from "./Type2Form.vue?vue&type=script&lang=js&"
export * from "./Type2Form.vue?vue&type=script&lang=js&"
import style0 from "./Type2Form.vue?vue&type=style&index=0&id=3d811569&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d811569",
  null
  
)

export default component.exports